import { Controller } from 'stimulus';
import simpleSerialize from '@/helpers/simpleSerialize';

class FiltersController extends Controller {
  onFilterChange() {
    const formData = simpleSerialize(this.formTarget, true);

    formData.sort_by = this.sortSelectTarget.value;

    this.fetchPage(formData)
      .then(FiltersController.extractProductsFromResponse)
      .then((productsElement) => {
        this.productsTarget.innerHTML = productsElement.innerHTML;
      });
  }

  fetchPage(formData) {
    return new Promise((resolve, reject) => {
      const formUrl = this.formTarget.getAttribute('action');

      $.ajax({
        url: formUrl,
        data: formData,
        success: resolve,
        error: reject,
      });
    });
  }

  onSortChange() {
    this.onFilterChange();
  }

  static extractProductsFromResponse(response) {
    const $products = $(response).find('[data-target="filters.products"]');

    if (!$products.length) {
      return Promise.reject();
    }

    return Promise.resolve($products[0]);
  }
}

FiltersController.targets = [
  'form',
  'sortSelect',
  'products',
];

export default FiltersController;
